import React, { useState, useEffect } from 'react'
import { Button, Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { useNavigate } from "react-router-dom";
import $ from 'jquery'
import { Link } from 'react-router-dom';

export default function Header() {

    const navigate = useNavigate();

    const navigatetohome = () => {
        navigate('/')
    }

    const [hover, setHover] = useState(false)
    const [mobileOpen, setMobileOpen] = useState(false)
    const [mobileSolutionsOpen, setMobileSolutionsOpen] = useState(false)

    const toggleMobileSolutions = () =>
        setMobileSolutionsOpen(prev => !prev)

    const toggleMobileMenu = () => setMobileOpen(!mobileOpen)
    const closeMobileMenu = () => setMobileOpen(false)

    const handleSolutionsHover = () => {
        setHover(true)
        console.log('Solutions hovered')
        // open dropdown
    }

    const handleSolutionsLeave = () => {
        setHover(false)

        console.log('Solutions hover left')
        // close dropdown
    }

    return (
        <header class="new_home_page header_new position-fixed start-0 end-0 top-0 z-3" style={{ backgroundColor: "rgb(40 39 114)", borderBottom: '1px solid #f5f5f50c', padding: '15px 0px' }}>
            <nav class="container_new navbar-expand-lg navbar-white" style={{ padding: "0px 15px", display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                <a class="navbar-brand" onClick={navigatetohome} style={{ maxWidth: '240px', height: '40px', cursor: 'pointer' }}>
                    <img src="assets/icons/Paybacck.svg" alt="Payback Logo" style={{ height: "40px", width: "auto" }} />
                </a>
                <button
                    onClick={toggleMobileMenu}
                    class="navbar-toggler" type="button" data-bs-target="#mainNavbar" aria-expanded="false" >
                    <span class="navbar-toggler-icon"
                        style={{ width: "28px", height: '28px', maxWidth: 'unset' }}>
                        <img
                            id="menu-icon"
                            src="../../assets/icons/menu.svg"
                            alt="menu"
                        />
                    </span>
                </button>
                <div class="collapse navbar-collapse justify-content-center" id="mainNavbar">
                    <ul class="navbar-nav mb-2 mb-lg-0 align-items-lg-center text-uppercase fw-semibold">
                        <li class="nav-item">
                            <Link class="nav-link" to="/">Home</Link>
                        </li>
                        <li class="nav-item dropdown"
                            onMouseEnter={handleSolutionsHover}
                            onMouseLeave={handleSolutionsLeave}>
                            <a class="nav-link sol d-flex align-items-center gap-1" href="#"
                            >
                                Solutions
                                <img src="assets/icons/Icon.svg" alt="" />
                            </a>
                            <ul
                                style={{ display: hover ? 'initial' : 'none' }}
                                class="dropdown_custom dropdown-menu animate__animated animate__fadeIn bg-white text-black rounded-3 shadow" aria-labelledby="solutionsDropdown">
                                {/* <li>
                                    <Link class="dropdown-item" to="/#ValueProposition"
                                        onClick={() => setHover(false)}

                                    >
                                        Value Proposition
                                    </Link>
                                </li>
                                <li>
                                    <Link class="dropdown-item" to="/#PaybacckHelps"

                                        onClick={() => setHover(false)}
                                    >
                                        Paybacck Helps
                                    </Link>
                                </li>
                                <li>
                                    <Link class="dropdown-item" to="/#PlatformPillars"
                                        onClick={() => setHover(false)}

                                    >
                                        Platform Pillars
                                    </Link>
                                </li>
                                <li>
                                    <Link class="dropdown-item" to="/#WhoFors"

                                        onClick={() => setHover(false)}
                                    >
                                        Who It’s Fors
                                    </Link>
                                </li> */}
                                <li>
                                    <Link class="dropdown-item" to="/home#deepdive"

                                        onClick={() => setHover(false)}
                                    >
                                        Paybacck DeepDive™ - Detailed Investment Evaluation
                                    </Link>
                                </li>
                                <li>
                                    <Link class="dropdown-item" to="/home#quickscan"

                                        onClick={() => setHover(false)}
                                    >
                                        Paybacck QuickScan™ - Quick Idea Evaluation
                                    </Link>
                                </li>
                                <li>
                                    <Link class="dropdown-item" to="/home#costcraft"

                                        onClick={() => setHover(false)}
                                    >
                                        Paybacck CostCraft™ - Detailed Cost Builder for Projects
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" to="/home#about-us">About Us</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" to="/#work">How It Works</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" to="/contact-us">Contact Us</Link>
                        </li>
                    </ul>
                </div>
                <div class="d-none d-lg-flex ">
                    <button onClick={() => navigate('/sign')} class="primary-button " style={{ padding: "11px 24px", fontWeight: '700', lineHeight: "21px", height: '45px' }} >Sign in</button>
                    <button onClick={() => navigate('/signup')} class="secondary-button" style={{ marginLeft: '16px' }} >Book a demo</button>
                </div>
            </nav>


            <div
                className="position-fixed end-0 h-100"
                style={{
                    top: '70px',
                    width: '75%',
                    maxWidth: '380px',
                    backgroundColor: 'rgb(40 39 114)',
                    transform: mobileOpen ? 'translateX(0)' : 'translateX(100%)',
                    transition: 'transform 0.4s ease-in-out',
                    zIndex: 999,
                    padding: '0px 24px 24px'
                }}
            >
                <nav className="d-flex flex-column gap-4  text-uppercase fw-semibold text-white">
                    <Link style={{ color: "#fff", fontWeight: 600, textTransform: 'uppercase' }} to="/" onClick={closeMobileMenu}>Home</Link>
                    <div style={{ position: 'relative' }} >
                        <span
                            onClick={toggleMobileSolutions}
                            style={{ cursor: 'pointer' }}
                            className="d-flex gap-1 align-items-center"
                        >
                            Solutions <img src="assets/icons/Icon.svg" alt="" />
                        </span>

                        {mobileSolutionsOpen && (
                            <div
                                className="dropdown_custom_mobile bg-white text-dark rounded shadow"
                                style={{
                                    position: 'absolute',
                                    top: '32px',
                                    left: '0',
                                    width: '220px',
                                    zIndex: 1000,
                                    animation: 'fadeIn 0.2s ease-in-out',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    padding: 5
                                }}
                            >
                                {/* <Link
                                    to="/#ValueProposition"
                                    onClick={closeMobileMenu}
                                >
                                    Value Proposition
                                </Link>
                                <Link
                                    to="/#PaybacckHelps"
                                    onClick={closeMobileMenu}
                                >
                                    Paybacck Helps
                                </Link>
                                <Link
                                    to="/#PlatformPillars"
                                    onClick={closeMobileMenu}
                                >
                                    Platform Pillars
                                </Link>
                                <Link
                                    to="/home#WhoFors"
                                    onClick={closeMobileMenu}
                                >
                                    Who It’s Fors
                                </Link> */}
                                <Link
                                    to="/home#deepdive"
                                    onClick={closeMobileMenu}
                                >
                                    Paybacck DeepDive™ - Detailed Investment Evaluation
                                </Link>
                                <Link
                                    to="/home#quickscan"
                                    onClick={closeMobileMenu}
                                >
                                    Paybacck QuickScan™ - Quick Idea Evaluation
                                </Link>
                                <Link
                                    to="/home#costcraft"
                                    onClick={closeMobileMenu}
                                >
                                    Paybacck CostCraft™ - Detailed Cost Builder for Projects
                                </Link>
                            </div>
                        )}
                    </div>


                    <Link
                        style={{ color: "#fff", fontWeight: 600, textTransform: 'uppercase' }}
                        to="/home#about-us" onClick={closeMobileMenu}>About Us</Link>
                    <Link
                        style={{ color: "#fff", fontWeight: 600, textTransform: 'uppercase' }}
                        to="/#work" onClick={closeMobileMenu}>How It Works</Link>
                    <Link
                        style={{ color: "#fff", fontWeight: 600, textTransform: 'uppercase' }}
                        to="/contact-us" onClick={closeMobileMenu}>Contact Us</Link>

                    {/* Mobile Buttons */}
                    <div className="d-flex flex-column gap-3 mt-4">
                        <button
                            onClick={() => {
                                navigate('/sign')
                                closeMobileMenu()
                            }}
                            className="primary-button w-100"
                        >
                            Sign in
                        </button>
                        <button
                            onClick={() => {
                                navigate('/signup')
                                closeMobileMenu()
                            }}
                            style={{padding: "13px 32px"}}
                            className="secondary-button w-100"
                        >
                            Book a demo
                        </button>
                    </div>
                </nav>
            </div>
        </header>

    )
}